<template>
  <div :class="containerClass">
    <svg :id="svgId" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514.87 299.06">

      <path class="cls-mx-4"
            d="M78.83,30.11L.5,37.87v260.64l60-6.24,326.85-35.29c18.97-1.88,36.61-7.46,53.24-15.93,16.2-8.09,30.21-19.14,41.93-31.95,11.35-13.24,19.99-27.88,25.5-43.53,5.59-16.84,7.59-33.95,5.59-51.33-1.59-17.35-6.89-33.36-15.86-48.43-9-14.66-20.13-27.47-34.25-37.68-14.09-10.61-30.01-18.14-47.34-22.56-18.11-4.88-36.06-6.13-55.04-4.25L78.83,30.11Z"/>
      <path class="cls-mx-2"
            d="M78.83,30.11L.5,37.87v260.64l60-6.24,326.85-35.29c18.97-1.88,36.61-7.46,53.24-15.93,16.2-8.09,30.21-19.14,41.93-31.95,11.35-13.24,19.99-27.88,25.5-43.53,5.59-16.84,7.59-33.95,5.59-51.33-1.59-17.35-6.89-33.36-15.86-48.43-9-14.66-20.13-27.47-34.25-37.68-14.09-10.61-30.01-18.14-47.34-22.56-18.11-4.88-36.06-6.13-55.04-4.25L78.83,30.11Z"/>
      <path class="cls-mx-3"
            d="M179.59,122.09c4.19,3.1,6.31,7.26,7.14,12.53l7.63,74.31,21-2.14-7.66-73.92c-1.21-11.31-5.79-20.45-14.15-27.05-8.33-7-18.97-9.75-30.25-8.93-12.54,1.53-21.76,7.3-28.13,18.08-8.59-9.02-18.74-12.94-31.25-11.81-11.31,1.21-20.91,6.56-27.51,14.92-7,8.33-9.29,18.2-8.48,29.48l8.06,73.94,20.63-2.57-8.06-73.94c-.03-5.21,1.1-9.95,4.2-14.14,3.1-4.19,7.66-6.28,13.3-6.69,5.64-.41,10.38.73,14.57,3.83,3.79,3.07,5.88,7.63,6.72,12.9l7.64,74.32,21.03-2.54-7.66-73.92c-.44-5.24.7-9.98,3.77-13.77,3.1-4.19,7.66-6.28,13.33-7.09,5.64-.41,10.38.73,14.14,4.2Z"/>
      <path class="cls-mx-3"
            d="M435.11,63.37l-88.84,9.02,2.32,24.22,43.65-4.97-21.82,42.58c10.17-2.09,17.89-3.56,23.1-3.6,16.9-.82,26,6.63,27.71,22.39.72,6.87-.89,12.77-5.25,17.68-3.53,4.57-9.34,7.37-16.63,8.46-13.34,1.48-22.26-2.76-26.44-11.87l-25.44,2.63c2.47,10.6,8.66,19.45,18.65,25.76,9.93,7.11,22.15,9.97,35.89,8.52,14.53-1.39,25.75-7.02,34.09-17.26,8.33-10.25,11.62-22.85,10.2-36.98-1.19-11.71-5.36-20.83-12.1-27.71-6.73-6.89-15.32-10.29-26.09-11.05l27-47.83Z"/>
      <polygon class="cls-mx-3"
               points="237.85 86.06 213.93 118.48 252.02 147.2 222.49 185.23 254.88 209.55 283.63 171.06 322.12 199.82 346.04 167.41 307.95 138.68 307.52 139.05 336.27 100.56 304.29 76.27 275.54 114.76 237.85 86.06"/>
      <polygon class="cls-mx-1"
               points="237.85 86.06 213.93 118.48 252.02 147.2 222.49 185.23 254.88 209.55 283.63 171.06 322.12 199.82 346.04 167.41 307.95 138.68 307.52 139.05 336.27 100.56 304.29 76.27 275.54 114.76 237.85 86.06"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: "SvgMx3",
  props: {
    containerClass: String,
    svgId: String
  }
}
</script>

<style scoped>

.cls-mx-1 {
  fill: none;
  stroke: #fff;
}

.cls-mx-1, .cls-mx-2 {
  stroke-miterlimit: 3.86;
}

.cls-mx-3 {
  fill: #fff;
  stroke: white;
}

.cls-mx-2, .cls-mx-4 {
  fill: var(color-black);
  stroke: var(color-black);

}

svg:hover .cls-mx-2, svg:hover .cls-mx-4 {

  fill: var(--color-random2);
  stroke: var(--color-random2);
}

.cls-mx-4 {
  stroke-miterlimit: 10;
}
</style>